module.exports = __webpack_public_path__ + "img/Error500.355f600c.png";